import React, { useState } from 'react';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ExportModalProps {
    show: boolean;
    onHide: () => void;
    htmlContent: string;
    jsonContent: string;
}

const _ExportModal: React.FC<ExportModalProps> = ({ show, onHide, htmlContent, jsonContent }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('html');
    const [copyStatus, setCopyStatus] = useState<'idle' | 'copied'>('idle');

    const handleCopy = () => {
        const contentToCopy = activeTab === 'html' ? htmlContent : jsonContent;
        navigator.clipboard.writeText(contentToCopy)
            .then(() => {
                setCopyStatus('copied');
                setTimeout(() => setCopyStatus('idle'), 2000);
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };

    const handleDownload = () => {
        const isHtml = activeTab === 'html';
        const content = isHtml ? htmlContent : jsonContent;
        const mimeType = isHtml ? 'text/html' : 'application/json';
        const fileName = isHtml ? 'design.html' : 'design.json';

        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const handlePreviewInNewTab = () => {
        const newTab = window.open();
        if (newTab) {
            newTab.document.write(htmlContent);
            newTab.document.close();
        }
    }

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("app.creation.preview.preview")}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "45vh" }}>
                {!htmlContent && (
                    <div className="text-muted p-3">
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        {t("app.creation.preview.loading")}
                    </div>
                )}
                {htmlContent && (
                    <div className="bg-light p-3 rounded text-muted">
                        {t("app.creation.preview.use")}
                        &nbsp;
                        <strong>
                            <span onClick={handleDownload} className="cursor-pointer">
                                <i className="fa-solid fa-download me-1"></i>
                                {t("app.creation.preview.downloadHtml")}
                                &nbsp;
                            </span>
                        </strong>
                        {t("app.creation.preview.or")}
                        &nbsp;
                        <strong>
                            <span onClick={handlePreviewInNewTab} className="cursor-pointer">
                                <i className="fa-solid fa-eye me-1"></i>
                                {t("app.creation.preview.previewNewTab")}
                            </span>
                        </strong>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t("app.creation.preview.close")}
                </Button>
                {/* {activeTab !== 'html' && (
                    <Button variant="primary" onClick={handleCopy} disabled={copyStatus === 'copied'}>
                        {copyStatus === 'copied' ? (
                            <><i className="fa-solid fa-check me-2"></i>Copied!</>
                        ) : (
                            <><i className="fa-solid fa-copy me-2"></i>Copy to Clipboard</>
                        )}
                    </Button>
                )} */}
                {activeTab === 'html' && (<Button
                    variant="info"
                    onClick={handlePreviewInNewTab}
                >
                    <i className="fa-solid fa-eye me-2"></i>
                    {t("app.creation.preview.previewNewTab")}
                </Button>)}
                <Button variant="success" onClick={handleDownload}>
                    <i className="fa-solid fa-download me-2"></i>
                    {t("app.creation.preview.downloadHtml")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default _ExportModal;
